import { CategoryFacade } from "../category/category.facade";
import { TaskTypeApiFacade } from "./task-type.api-facade";
import { TaskType } from "./task-type.model";
import { TaskTypeStoreFacade } from "./task-type.store-facade";

export class TaskTypeFacade extends CategoryFacade<TaskType, TaskTypeApiFacade, TaskTypeStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/task-type/task-type.facade.ts